export default "mutation Logout{logout_v2(flow:websiteSession)}"